import { defineStore } from 'pinia'
import { ref } from 'vue'
import dayjs from 'dayjs'
import { i18n, loadDbTranslations } from '@/i18n'

export const useAppStore = defineStore('app', () => {
  const isSidebarCollapsed = ref(localStorage.getItem('dz_sidebar_collapsed') === 'true')
  const isMobileSidebarOpen = ref(false)
  const currentLang = ref<'tk' | 'ru'>((localStorage.getItem('dz_lang') as 'tk' | 'ru') || 'tk')

  function toggleSidebar() {
    if (window.innerWidth <= 768) {
      isMobileSidebarOpen.value = !isMobileSidebarOpen.value
    } else {
      isSidebarCollapsed.value = !isSidebarCollapsed.value
      localStorage.setItem('dz_sidebar_collapsed', String(isSidebarCollapsed.value))
    }
  }

  function closeMobileSidebar() {
    isMobileSidebarOpen.value = false
  }

  function openMobileSidebar() {
    isMobileSidebarOpen.value = true
  }

  async function setLanguage(lang: 'tk' | 'ru') {
    currentLang.value = lang
    localStorage.setItem('dz_lang', lang)
    dayjs.locale(lang)
    // Synchronize ASP.NET Core culture cookie so Razor Pages match the language
    document.cookie = `.AspNetCore.Culture=c%3D${lang}%7Cuic%3D${lang};path=/;max-age=31536000`
    
    // Switch vue-i18n reactively
    ;(i18n.global.locale as any).value = lang
    await loadDbTranslations(lang)
  }

  return {
    isSidebarCollapsed,
    isMobileSidebarOpen,
    currentLang,
    toggleSidebar,
    closeMobileSidebar,
    openMobileSidebar,
    setLanguage
  }
})
